import React from "react";

const AdmissionSlip = () => {
  return <div>AdmissionSlip</div>;
};

export default AdmissionSlip;
